import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import { Dropdown } from 'components/v2/Dropdown'
import List from 'components/v2/List'
import { StyledLink } from 'components/v2/Link'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { typeMessages } from 'features/Inventories/components/Type/messages'
import { InventoriesActions } from './Actions'
import { safeFormatMessage } from 'utils/intl'
import { isSuperAdmin, canWriteInventory } from 'features/Users/utils'
import { GTInventory } from 'gql/types.generated'
import { useLogin } from 'features/Login/hooks'

const UserItem = styled.div`
  white-space: nowrap;
`

export const InventoriesList = ({ inventories = [] }: { inventories: GTInventory[] }): ReactElement => {
  const intl = useIntl()
  const login = useLogin()
  const showCompany = isSuperAdmin(login.accessToken.conditions)

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWriteInventory(login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="spanish.ictionary.name" defaultMessage="Nombre" />
            </Th>
            <Th>
              <FormattedMessage id="spanish.dictionary.city" defaultMessage="Ciudad" />
            </Th>
            <Th>
              <FormattedMessage id="spanish.dictionary.type" defaultMessage="Tipo" />
            </Th>
            <Th>
              <FormattedMessage id="spanish.dictionary.users" defaultMessage="Usuarios" />
            </Th>
            {showCompany && (
              <Th>
                <FormattedMessage id="spanish.dictionary.company" defaultMessage="Compañía" />
              </Th>
            )}
          </Tr>
        </Thead>
        <Tbody>
          {inventories.map((inventory): ReactElement => {
            return (
              <Tr key={inventory.id}>
                {canWriteInventory(login.accessToken.policies) && (
                  <Td>
                    <InventoriesActions inventory={inventory} />
                  </Td>
                )}
                <Td>
                  <StyledLink as={NavLink} to={`/inventories/${inventory.id}/items`}>
                    {inventory.name}
                  </StyledLink>
                </Td>
                <Td>{inventory.address && inventory.address.city ? inventory.address.city.name : '-'}</Td>
                <Td>{safeFormatMessage({ intl, messages: typeMessages, key: inventory.type })}</Td>
                <Td>
                  {inventory.users.length > 0 ? (
                    <Dropdown toggle={<StyledLink>{inventory.users.length}</StyledLink>} noPadding fitContent>
                      <List.Container>
                        {inventory.users.map((user: TSFixMe): TSFixMe => {
                          return (
                            <List.Item key={user.id}>
                              <UserItem>
                                {user.firstName} {user.lastName} ({user.username})
                              </UserItem>
                            </List.Item>
                          )
                        })}
                      </List.Container>
                    </Dropdown>
                  ) : (
                    0
                  )}
                </Td>
                {showCompany && <Td>{inventory.company.name}</Td>}
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
